import axios from 'axios';
import Qs from 'qs';

const instance = axios.create({
  baseURL: '',
  'Access-Control-Allow-Origin':'*',
  withCredentials: true
});

instance.interceptors.request.use((config) => {
  return config;
});

instance.interceptors.response.use(async (res) => {
  return res.data
});

export default (url, params, method) => {
  if (method.type === 'GET') {
    return instance({
      url: url,
      method: 'get',
      params: params
    });
  } else {
    const config = {
      url,
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: Qs.stringify({
        ...params,
      })
    };
    return instance(config);
  }
};
